import { GlobalApplicationContext } from "../application/GlobalApplicationContext";
export const SYM_ROOT_CONTAINER = Symbol();
/**
 * A Vue.js plugin to support dependency injection, thanks to Inversify.
 */
export function InversifyPlugin() {
    return {
        install: (_Vue) => {
            Object.defineProperty(_Vue.prototype, SYM_ROOT_CONTAINER, {
                get() {
                    return GlobalApplicationContext.default.fastoche.rootContainer;
                },
            });
        },
    };
}
//# sourceMappingURL=InversifyPlugin.js.map